import {Dispatch, lazy, ReactNode, SetStateAction, Suspense} from 'react';
import {BaseUser, BodySite, Condition, ScoringSystemItem, ScoringSystem} from '@legit-health/ui';
import Skeleton from '@mui/material/Skeleton';
import {TFunction} from 'i18next';
import {AnamnesisQuestion} from '@/shared/interfaces/AnamnesisQuestion';
import isAlopeciaFn from '@/shared/utils/isAlopecia';
import {ConditionInfo, CreateDiagnosticReportResponse} from '../../types';

const FollowUpForm = lazy(() => import('./FollowUpForm'));
const Alopecia = lazy(() => import('./components/Alopecia'));

export default function FollowUpFormContainer(props: {
  anamnesisQuestions: AnamnesisQuestion[];
  conditionId: string;
  conditions: Condition[];
  conditionInfo: ConditionInfo | null;
  currentStep: number;
  extraPostData?: (conditionId: string | null) => Record<string, any>;
  isForClinicalTrials: boolean;
  onSuccess: (values: CreateDiagnosticReportResponse) => void;
  patient: BaseUser;
  renderItemLabel?: (options: {
    item: ScoringSystemItem;
    scoringSystem: ScoringSystem;
    bodySite: BodySite;
  }) => string;
  setCurrentStep: Dispatch<SetStateAction<number>>;
  steps: {label: string; icon: ReactNode}[];
  t: TFunction;
  visitIdentifier: string;
  withTemporaryImages: boolean;
  fullBody: boolean;
  pathologyId: string | null;
}) {
  const condition = props.conditions.find((c) => c.id === parseInt(props.conditionId));
  if (!condition) {
    throw new Error(`Invalid condition id: ${props.conditionId}`);
  }
  const isAlopecia = isAlopeciaFn(condition.pathology);
  if (isAlopecia) {
    return (
      <Suspense fallback={<Skeleton variant="rectangular" width="100%" height={400} />}>
        <Alopecia {...props} condition={condition} />
      </Suspense>
    );
  }
  return (
    <Suspense fallback={<Skeleton variant="rectangular" width="100%" height={400} />}>
      <FollowUpForm {...props} condition={condition} />
    </Suspense>
  );
}
